import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Listbox, Combobox } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  LinkIcon,
  ColorSwatchIcon,
  CogIcon,
  MinusIcon,
  PlusIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class InventoryEditmodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      editid: this.props.InventoryadjustmentId,
      modeofadjustmentList: [],
      inventoryadjustmentstatesList: [],
      purchaseorderaccountnamesList: [],
      invadjreasonList: [],
      branchesList: [],
      warehousesList: [],
      warehouseitemList: [],
      inventory_adjustment_items_delete: [],
      mode_of_adjustment_id: "",
      inventory_adjustment_state_id: 1,
      modeofpaymentInputshowqty: false,
      modeofpaymentInputshowval: false,
      referrence_no: "",
      date: "",
      account_id: 0,
      reason_id: 0,
      branch_id: 0,
      warehouse_id: 0,
      description: "",
      msg: "",
      icon: "",
      showmsgforItem: "",
      showmsgforItemNotify: false,
      inventory_adjustment_items: [],

      queryItem: "",
      error_list: [],
      overLay: "",
      loader: "animate-pulse",
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleInputInv = this.handleInputInv.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/modeofadjustment", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ modeofadjustmentList: res.data.mode_of_adjustments });
      });

    const res1 = axios
      .get("public/api/inventoryadjustment/state", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({
          inventoryadjustmentstatesList: res1.data.inventory_adjustment_states,
        });
      });

    const res2 = axios
      .get("public/api/inventoryadjustment/account", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({
          purchaseorderaccountnamesList: res2.data.account_names,
        });
      });

    const res3 = axios
      .get("public/api/reason", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ invadjreasonList: res3.data.reasons });
      });

    const res4 = axios
      .get("public/api/branch", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({ branchesList: res4.data.branches });
      });

    const resEdit = axios
      .get("public/api/inventory/adjustment/edit/" + this.state.editid, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((resEdit) => {
        this.setState({
          referrence_no: resEdit.data.inventory_adjustment.referrence_no,
          mode_of_adjustment_id:
            resEdit.data.inventory_adjustment.mode_of_adjustment_id,
          date: resEdit.data.inventory_adjustment.date,
          account_id: resEdit.data.inventory_adjustment.account_id,
          reason_id: resEdit.data.inventory_adjustment.reason_id,
          branch_id: resEdit.data.inventory_adjustment.branch_id,
          warehouse_id: resEdit.data.inventory_adjustment.warehouse_id,
          description: resEdit.data.inventory_adjustment.description,
          warehousesList:
            resEdit.data.inventory_adjustment.warehouse_for_branch,
          warehouseitemList: resEdit.data.items,
        });
        if (resEdit.data.inventory_adjustment.mode_of_adjustment_id == 1) {
          this.setState({ modeofpaymentInputshowqty: true });
          this.setState({ modeofpaymentInputshowval: false });
        }

        if (resEdit.data.inventory_adjustment.mode_of_adjustment_id == 2) {
          this.setState({ modeofpaymentInputshowval: true });
          this.setState({ modeofpaymentInputshowqty: false });
        }
        this.state.inventory_adjustment_items = [];
        resEdit.data.inventory_adjustment.inventory_adjustment_items.map(
          (value, index) => {
            this.state.inventory_adjustment_items.push({
              id: value.id,
              inventory_adjustment_item_id: value.inventory_adjustment_item_id,
              item_name: value.item_name,
              item_description: value.item_description,
              quantity_available: value.quantity_available,
              new_quantity_onhand: value.new_quantity_onhand,
              quantity_adjusted: value.quantity_adjusted,
              rate: value.rate,
              current_value: value.current_value,
              changed_value: value.changed_value,
              adjusted_value: value.adjusted_value,
            });
          }
        );

        this.setState({
          inventory_adjustment_items: this.state.inventory_adjustment_items,
        });
      });

    setTimeout(
      function () {
        //Start the timer
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name == "branch_id") {
      this.setLoaderFunction();
      const res5 = axios
        .get("public/api/branch/warehouse/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res5) => {
          this.setState({ warehousesList: res5.data.warehouses });
          this.closeLoaderFuncion();
        });
    }
    if (e.target.name == "warehouse_id") {
      this.setLoaderFunction();
      const res6 = axios
        .get("public/api/items/for/warehouse/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res6) => {
          this.setState({ warehouseitemList: res6.data.warehouse_items });
          this.closeLoaderFuncion();
        });
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputInv = (e) => {
    this.state.mode_of_adjustment_id = e.target.id;
    this.setState({
      mode_of_adjustment_id: e.target.id,
    });

    if (e.target.id == 1) {
      this.setState({ modeofpaymentInputshowqty: true });
      this.setState({ modeofpaymentInputshowval: false });
    }
    if (e.target.id == 2) {
      this.setState({ modeofpaymentInputshowval: true });
      this.setState({ modeofpaymentInputshowqty: false });
    }
  };

  addinventoryItem = (e) => {
    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items.concat([
        {
          inventory_adjustment_item_id: "",
          item_name: 0,
          item_description: 0,
          quantity_available: 0,
          new_quantity_onhand: 0,
          quantity_adjusted: 1,
          rate: 1,
          current_value: 0,
          changed_value: 0,
          adjusted_value: 1,
        },
      ]),
    });
  };

  handleInputnewquantityonhand = (InventoryItemIndex) => (e) => {
    this.state.inventory_adjustment_items[
      InventoryItemIndex
    ].new_quantity_onhand = e.target.value;

    let qtyadj =
      parseFloat(e.target.value) -
      parseFloat(
        this.state.inventory_adjustment_items[InventoryItemIndex]
          .quantity_available
      );
      console.log(qtyadj);
      console.log(e.target.value-this.state.inventory_adjustment_items[InventoryItemIndex]
        .quantity_available);
    this.state.inventory_adjustment_items[
      InventoryItemIndex
    ].quantity_adjusted = qtyadj;

    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };
  handleInputAdjustedquantityonhand =(InvoiceItemIndex)=>(e)=>{

    let one=parseInt(this.state.inventory_adjustment_items[
      InvoiceItemIndex
    ].quantity_available)+parseInt(e.target.value);

    this.state.inventory_adjustment_items[
      InvoiceItemIndex
    ].new_quantity_onhand=one;

    this.state.inventory_adjustment_items[InvoiceItemIndex].quantity_adjusted =
    e.target.value;

  this.setState({
    inventory_adjustment_items: this.state.inventory_adjustment_items,
  });

  }

  handleInputchangedvalue = (InventoryItemIndex) => (e) => {
    this.state.inventory_adjustment_items[InventoryItemIndex].changed_value =
      e.target.value;

    let valadj =
      parseFloat(e.target.value) -
      parseFloat(
        this.state.inventory_adjustment_items[InventoryItemIndex].current_value
      );

    this.state.inventory_adjustment_items[InventoryItemIndex].adjusted_value =
      valadj;
    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };
  handleInputAdjustedvalue=(InvoiceItemIndex)=>(e)=>{
    let one=parseFloat(
      this.state.inventory_adjustment_items[InvoiceItemIndex].current_value
    )+parseFloat(e.target.value);
    console.log(one);
    this.state.inventory_adjustment_items[InvoiceItemIndex].changed_value =
    one;

    
    this.state.inventory_adjustment_items[InvoiceItemIndex].adjusted_value =
    e.target.value;
    
    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  }

  handleinputCostrate = (InvoiceItemIndex) => (e) => {
    this.state.inventory_adjustment_items[InvoiceItemIndex].rate =
      e.target.value;
    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleInputwarehouseAE(e);
  };

  saveItem = async (e) => {
    e.preventDefault();
    let adjustval=0;
    let quantity_adjusted=0;
    
   this.state.inventory_adjustment_items.map((item) =>{
      
  
      if(this.state.mode_of_adjustment_id==1){
        
        if(item.quantity_adjusted==0){
          quantity_adjusted=1;
        }
      }
      if(this.state.mode_of_adjustment_id==2){
        if(item.adjusted_value==0){
        
          adjustval=1;
        
        }
      }
   });


    this.setLoaderFunction();
    if (this.state.inventory_adjustment_items.length > 0) {
      if(adjustval==0&&quantity_adjusted==0){
      var token = localStorage.getItem("token");
      const headers = {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      };

      const res = await axios.post(
        "public/api/inventory/adjustment/update/" + this.state.editid,
        this.state,
        {
          headers,
        }
      );

      if (res.data.success) {
        //this.setState({ showmsg: true });
        this.setState({ icon: res.data.success });
        this.handleInputwarehouseF(res.data.success);
        setTimeout(
          function () {
            //Start the timer
            this.setState({ redirect: true }); //After 1 second, set render to true
          }.bind(this),
          1000
        );
        this.closeLoaderFuncion();
      } else {
        this.setState({ icon: res.data.success });
        if (res.data.data != undefined) {
          this.state.error_list = res.data.data;
          this.setState({ error_list: this.state.error_list });
          this.setState({ showmsg: true });

          this.setState({ msg: res.data.message });
        } else {
          console.log("error msg1");
          this.state.error_list = [];
          this.setState({ showmsg: true });
          this.setState({ msg: res.data.message });
        }

        // console.log(this.state.error_list);
        this.closeLoaderFuncion();
        //this.setState({ show: true })
      }
      this.closeLoaderFuncion();
    }
    this.closeLoaderFuncion();
    if(adjustval==1){
      this.setState({ showmsgforItemNotify: true });
      this.setState({
        showmsgforItem: "Adjusted value can not be Zero",
      });
    }
    if(quantity_adjusted==1){
      this.setState({ showmsgforItemNotify: true });
      this.setState({
        showmsgforItem: "Adjusted Quantity can not be Zero",
      });
    }
    this.closeLoaderFuncion();
  
  }
  adjustval=0;
  quantity_adjusted=0;
    if (this.state.inventory_adjustment_items.length === 0) {
      this.setState({ showmsgforItemNotify: true });
      this.setState({
        showmsgforItem: "Item Details cannot be empty",
      });
    }
  };

  markasconvert = (e) => {
    this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const res = axios
      .get("public/api/inventory/convert/to/adjustment/" + this.state.editid, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ icon: res.data.success });
          this.state.msg = res.data.message;
          this.setState({ msg: this.state.msg });

          this.setState({ showmsg: true });

          setTimeout(
            function () {
              //Start the timer
              this.setState({ showmsg: false });
            }.bind(this),
            1000
          );
          this.closeLoaderFuncion();
        } else {
          this.setState({ icon: res.data.success });
          this.state.msg = res.data.message;
          this.setState({ msg: this.state.msg });

          this.setState({ showmsg: true });

          setTimeout(
            function () {
              //Start the timer
              this.setState({ showmsg: false });
            }.bind(this),
            1000
          );
          this.closeLoaderFuncion();
          //this.setState({ show: true })
        }
        setTimeout(
          function () {
            //Start the timer
            this.handleInputwarehouseF(true);
          }.bind(this),
          1000
        );
      });

    this.closeLoaderFuncion();
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");
      setTimeout(
        function () {
          //Start the timer
          this.setState({ logoutRedirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    }
  };
  //Logout function
  handleInputtwo = (e) => {
    this.setState({
      queryItem: e.target.value,
    });
  };
  handleInputSelectItem = (InventoryItemIndex) => (e) => {
    this.state.inventory_adjustment_items[
      InventoryItemIndex
    ].inventory_adjustment_item_id = e.id;
    this.state.inventory_adjustment_items[InventoryItemIndex].item_name =
      e.name;
    this.state.inventory_adjustment_items[
      InventoryItemIndex
    ].quantity_available = e.opening_stock;

    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };
  handleInputSelectItemvalue = (InvoiceItemIndex) => (e) => {
    this.state.inventory_adjustment_items[
      InvoiceItemIndex
    ].inventory_adjustment_item_id = e.id;
    this.state.inventory_adjustment_items[InvoiceItemIndex].item_name = e.name;

    this.state.inventory_adjustment_items[InvoiceItemIndex].rate =
      e.purchase_cost_price;
    this.state.inventory_adjustment_items[InvoiceItemIndex].current_value =
      e.total_purchase_amount_using_fifo;

    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };
  deleteinventoryItem = (InventoryItemIndex) => {
    let getInvoiceItemId =
      this.state.inventory_adjustment_items[InventoryItemIndex]["id"];

    if (getInvoiceItemId !== undefined) {
      this.state.inventory_adjustment_items_delete.push({
        id: getInvoiceItemId,
      });
    }

    this.state.inventory_adjustment_items =
      this.state.inventory_adjustment_items.filter(
        (s, sidx) => InventoryItemIndex !== sidx
      );
    this.setState({
      inventory_adjustment_items: this.state.inventory_adjustment_items,
    });
  };

  render() {
    const filteredItem =
      this.state.queryItem === ""
        ? this.state.warehouseitemList
        : this.state.warehouseitemList.filter((warehouseitemList) => {
            return warehouseitemList.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

    const TableHeaderqty = () => (
      <tr className="divide-x divide-gray-200">
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
            Item Details
          </span>
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Quantity Available
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          New Quantity On Hand
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Quantity Adjusted
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Cost Rate
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Delete
        </th>
      </tr>
    );
    const TableHeaderval = () => (
      <tr className="divide-x divide-gray-200">
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
            Item Details
          </span>
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Current value
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Changed Value
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Adjusted Value
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Delete
        </th>
      </tr>
    );
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div className={this.state.overLay} aria-hidden="true" />
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Update Inventory Adjustments
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <div>
                                <label className="text-base font-medium text-gray-900">
                                  Mode of Adjustments
                                </label>

                                <fieldset className="mt-4">
                                  <legend className="sr-only"></legend>
                                  <div onChange={this.handleInputInv}>
                                    <div className="space-y-4">
                                      {this.state.modeofadjustmentList.map(
                                        (modeofadjustment) => (
                                          <div
                                            key={modeofadjustment.id}
                                            className="flex items-center"
                                          >
                                            <input
                                              id={modeofadjustment.id}
                                              name="mode_of_adjustment_id"
                                              type="radio"
                                              disabled={true}
                                              checked={
                                                modeofadjustment.id ==
                                                this.state.mode_of_adjustment_id
                                              }
                                              className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                            />
                                            <label
                                              htmlFor={modeofadjustment.id}
                                              className="ml-3 block text-sm font-medium text-gray-700"
                                            >
                                              {modeofadjustment.name}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="referrence_no"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Referrence No
                              </label>
                              <input
                                type="text"
                                name="referrence_no"
                                onChange={this.handleInput}
                                value={this.state.referrence_no}
                                id="referrence_no"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="referrence_no-error"
                              >
                                {this.state.error_list.referrence_no}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="date"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Date
                                </span>
                              </label>
                              <input
                                type="date"
                                name="date"
                                value={this.state.date}
                                onChange={this.handleInput}
                                id="date"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="date-error"
                              >
                                {this.state.error_list.date}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="account_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Account
                                </span>
                              </label>
                              <select
                                id="account_id"
                                name="account_id"
                                onChange={this.handleInput}
                                value={this.state.account_id}
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.purchaseorderaccountnamesList.map(
                                  (number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="account_id-error"
                              >
                                {this.state.error_list.date}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="reason_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                {" "}
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Reason
                                </span>
                              </label>
                              <select
                                id="reason_id"
                                name="reason_id"
                                value={this.state.reason_id}
                                onChange={this.handleInput}
                                autoComplete="reason_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.invadjreasonList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="reason_id-error"
                              >
                                {this.state.error_list.reason_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="branch_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Branch
                                </span>
                              </label>
                              <select
                                id="branch_id"
                                name="branch_id"
                                value={this.state.branch_id}
                                onChange={this.handleInput}
                                autoComplete="branch_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.branchesList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="branch_id-error"
                              >
                                {this.state.error_list.branch_id
                                  ? this.state.error_list.branch_id[0]
                                  : ""}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="warehouse_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Warehouse
                                </span>
                              </label>
                              <select
                                id="warehouse_id"
                                name="warehouse_id"
                                value={this.state.warehouse_id}
                                onChange={this.handleInput}
                                autoComplete="warehouse_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.warehousesList.map((number) => (
                                  <option value={number.id}>
                                    {number.warehouse_name}
                                  </option>
                                ))}
                              </select>{" "}
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_id-error"
                              >
                                {this.state.error_list.warehouse_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="description"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Description
                              </label>
                              <input
                                type="text"
                                name="description"
                                id="description"
                                value={this.state.description}
                                onChange={this.handleInput}
                                autoComplete="description"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="description-error"
                              >
                                {this.state.error_list.description}
                              </p>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="px-4 py-5 overflow-x-auto  bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50">
                                {this.state.modeofpaymentInputshowqty ? (
                                  <TableHeaderqty />
                                ) : (
                                  <TableHeaderval />
                                )}
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.modeofpaymentInputshowqty
                                  ? this.state.inventory_adjustment_items.map(
                                      (Itemsi, index) => (
                                        <tr
                                          key={index}
                                          className="divide-x divide-gray-200"
                                        >
                                          <td className="">
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                              <Combobox
                                                as="div"
                                                value={Itemsi}
                                                onChange={this.handleInputSelectItem(
                                                  index
                                                )}
                                              >
                                                <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                                <div className="relative mt-1">
                                                  <Combobox.Input
                                                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                    onChange={
                                                      this.handleInputtwo
                                                    }
                                                    displayValue={(Items) =>
                                                      typeof Items.item_name !==
                                                        "undefined" &&
                                                      Items.item_name != null
                                                        ? Items.item_name
                                                        : ""
                                                    }
                                                  />
                                                  <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                    <SelectorIcon
                                                      className="h-5 w-5 text-gray-400"
                                                      aria-hidden="true"
                                                    />
                                                  </Combobox.Button>

                                                  {filteredItem.length > 0 && (
                                                    <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                      {filteredItem.map(
                                                        (itemLine) => (
                                                          <Combobox.Option
                                                            key={
                                                              itemLine.id_crypt
                                                            }
                                                            value={itemLine}
                                                            className={({
                                                              active,
                                                            }) =>
                                                              classNames(
                                                                "relative cursor-default select-none py-2 pl-3 pr-9",
                                                                active
                                                                  ? "bg-indigo-600 text-white"
                                                                  : "text-gray-900"
                                                              )
                                                            }
                                                          >
                                                            {({
                                                              active,
                                                              selected,
                                                            }) => (
                                                              <>
                                                                <span
                                                                  className={classNames(
                                                                    "block truncate",
                                                                    selected &&
                                                                      "font-semibold"
                                                                  )}
                                                                >
                                                                  {
                                                                    itemLine.name
                                                                  }
                                                                </span>

                                                                {selected && (
                                                                  <span
                                                                    className={classNames(
                                                                      "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                      active
                                                                        ? "text-white"
                                                                        : "text-indigo-600"
                                                                    )}
                                                                  >
                                                                    <CheckIcon
                                                                      className="h-5 w-5"
                                                                      aria-hidden="true"
                                                                    />
                                                                  </span>
                                                                )}
                                                              </>
                                                            )}
                                                          </Combobox.Option>
                                                        )
                                                      )}
                                                    </Combobox.Options>
                                                  )}
                                                </div>
                                              </Combobox>
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {}
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                              <input
                                                type="number"
                                                name="quantity_available"
                                                id="quantity_available"
                                                value={
                                                  Itemsi.quantity_available
                                                }
                                                readOnly
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .quantity_available
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1 ">
                                              <input
                                                type="number"
                                                name="new_quantity_onhand"
                                                onChange={this.handleInputnewquantityonhand(
                                                  index
                                                )}
                                                id="new_quantity_onhand"
                                                value={
                                                  Itemsi.new_quantity_onhand
                                                }
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .new_quantity_onhand
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                              <input
                                                type="number"
                                                name="quantity_adjusted"
                                                id="quantity_adjusted"
                                                onChange={this.handleInputAdjustedquantityonhand(
                                                  index
                                                )}
                                                value={Itemsi.quantity_adjusted}
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .quantity_adjusted
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                              <input
                                                type="number"
                                                name="rate"
                                                id="rate"
                                                onChange={this.handleinputCostrate(
                                                  index
                                                )}
                                                value={Itemsi.rate}
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {this.state.error_list.rate}
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  this.deleteinventoryItem(
                                                    index
                                                  )
                                                }
                                                className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                              >
                                                <MinusIcon
                                                  className="h-5 w-5"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )
                                  : this.state.inventory_adjustment_items.map(
                                      (Itemsi, index) => (
                                        <tr
                                          key={index}
                                          className="divide-x divide-gray-200"
                                        >
                                          <td className="">
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                              <Combobox
                                                as="div"
                                                value={Itemsi}
                                                onChange={this.handleInputSelectItemvalue(
                                                  index
                                                )}
                                              >
                                                <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                                <div className="relative mt-1">
                                                  <Combobox.Input
                                                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                    onChange={
                                                      this.handleInputtwo
                                                    }
                                                    displayValue={(Items) =>
                                                      typeof Items.item_name !==
                                                        "undefined" &&
                                                      Items.item_name != null
                                                        ? Items.item_name
                                                        : ""
                                                    }
                                                  />
                                                  <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                    <SelectorIcon
                                                      className="h-5 w-5 text-gray-400"
                                                      aria-hidden="true"
                                                    />
                                                  </Combobox.Button>

                                                  {filteredItem.length > 0 && (
                                                    <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                      {filteredItem.map(
                                                        (itemLine) => (
                                                          <Combobox.Option
                                                            key={
                                                              itemLine.id_crypt
                                                            }
                                                            value={itemLine}
                                                            className={({
                                                              active,
                                                            }) =>
                                                              classNames(
                                                                "relative cursor-default select-none py-2 pl-3 pr-9",
                                                                active
                                                                  ? "bg-indigo-600 text-white"
                                                                  : "text-gray-900"
                                                              )
                                                            }
                                                          >
                                                            {({
                                                              active,
                                                              selected,
                                                            }) => (
                                                              <>
                                                                <span
                                                                  className={classNames(
                                                                    "block truncate",
                                                                    selected &&
                                                                      "font-semibold"
                                                                  )}
                                                                >
                                                                  {
                                                                    itemLine.name
                                                                  }
                                                                </span>

                                                                {selected && (
                                                                  <span
                                                                    className={classNames(
                                                                      "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                      active
                                                                        ? "text-white"
                                                                        : "text-indigo-600"
                                                                    )}
                                                                  >
                                                                    <CheckIcon
                                                                      className="h-5 w-5"
                                                                      aria-hidden="true"
                                                                    />
                                                                  </span>
                                                                )}
                                                              </>
                                                            )}
                                                          </Combobox.Option>
                                                        )
                                                      )}
                                                    </Combobox.Options>
                                                  )}
                                                </div>
                                              </Combobox>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                              <input
                                                type="text"
                                                name="current_value"
                                                value={Itemsi.current_value}
                                                id="current_value"
                                                readOnly
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .current_value
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                              <input
                                                type="text"
                                                name="changed_value"
                                                onChange={this.handleInputchangedvalue(
                                                  index
                                                )}
                                                id="changed_value"
                                                value={Itemsi.changed_value}
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .changed_value
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            {" "}
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                              <input
                                                type="text"
                                                name="adjusted_value"
                                                id="adjusted_value"
                                                value={Itemsi.adjusted_value}
                                                onChange={this.handleInputAdjustedvalue(
                                                  index
                                                )}
                                                autoComplete="address-level2"
                                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                              />
                                              <p
                                                className="mt-2 text-sm text-red-600"
                                                id="email-error"
                                              >
                                                {
                                                  this.state.error_list
                                                    .adjusted_value
                                                }
                                              </p>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  this.deleteinventoryItem(
                                                    index
                                                  )
                                                }
                                                className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                              >
                                                <MinusIcon
                                                  className="h-5 w-5"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                              </tbody>
                              <tfoot>
                                <tr className="divide-x divide-gray-200">
                                  <td>
                                    <button
                                      type="button"
                                      className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                      onClick={this.addinventoryItem}
                                    >
                                      <PlusIcon
                                        className="-ml-1 mr-2 h-5 w-5"
                                        aria-hidden="true"
                                      />
                                      Add
                                    </button>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={() => this.markasconvert()}
                              className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                              Convert to Adjustment
                            </button>
                            <button
                              type="submit"
                              disabled={
                                this.state.inventory_adjustment_state_id == 2
                                  ? true
                                  : false
                              }
                              className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      {this.state.icon ? (
                        <CheckCircleIcon
                          className="h-6 w-6 text-green-400"
                          aria-hidden="true"
                        />
                      ) : (
                        <XCircleIcon
                          className="h-6 w-6 text-red-400"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.msg}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*stock Message*/}

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsgforItemNotify}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.showmsgforItem}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({
                            showmsgforItemNotify: false,
                            showmsgforItem: "",
                          });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*stock Message*/}
      </>
    );
  }
}

export default InventoryEditmodal;
